import { http } from "../../config/HttpMethod";
import { onCalculatePayload, saveProjectPayload } from "../../store/model/calculations/calculation";
import { MainReport } from "../../store/model/calculations/MainReport";
import { SchematicsModel } from "../../store/model/calculations/schematics";
import { toLocalISOString } from "../../utilities/commonUtilities";
import { ESP_ENDPOINTS } from "./endpoints";

export const getCalculations = async (payload: any) => {
    try {
        const params = payload;
        const response = await http.get(`${ESP_ENDPOINTS?.GET_CALCULATIONS}`, { params });
        return response?.data
    } catch (err) {
        throw err;
    }
};

export const onCalculate = async (payload: onCalculatePayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.ON_CALCULATE}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const saveProject = async (payload: saveProjectPayload) => {
    const params = {
        Lifttype: payload?.Lifttype,
        NameSearch: payload?.ESPInputViewModel,
        SeatSearch: { ESPBasicCalculation: payload?.ESPCalculation },
        FormsModel: {
            BasicGasCalculation: payload?.basicCalculation,
            BasicTDHCalculation: payload?.basicTDHCalculation,
            PumpInputModel: payload?.PumpModel,
            MotorInputModel: payload?.MotorInputModel,
            WellSurveyESPAssembly: payload?.WellSurveyESPAssembly
        },
        WellSurveySamples: payload?.SurveyData,
        Region: payload?.region,
        ProjectData: payload?.ProjectData,
        ComparisonCaseId1: payload?.ComparisonCaseId1,
        ComparisonCaseId2: payload?.ComparisonCaseId2,
        ComparisonCaseId3: payload?.ComparisonCaseId3,
        AIEnabled: payload?.AIEnabled,
        CreatedOn: toLocalISOString(new Date())
    }
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.SAVE_PROJECT}`, params);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const postSchematicsData = async (schematics: any) => {
    try {
        const response = await http.post<any>(`${ESP_ENDPOINTS?.SAVE_SCHEMATICS}`, schematics);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getSchematicData = async (payload: string) => {
    const params = {
        projectId: payload
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SCHEMATIC_DATA}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const FetchSetDepth = async (schematicData: SchematicsModel) => {
    try {
        const response = await http.post<SchematicsModel>(`${ESP_ENDPOINTS?.GET_SET_DEPTH}`, schematicData);
        return response;
    } catch (err) {
        console.log(err, 'error');
        throw err;
    }
};

export const getSurfaceVoltageValue = async (maximumFrequency: number, totalVoltageDropMaxLoad: number, motorNPVolts: number | null) => {
    const params = {
        maximumFrequency,
        totalVoltageDropMaxLoad,
        motorNPVolts
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SURFACE_VOLTAGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
}

export const GetMotorLoadDifferentFrequency = async (motorLoadFrequency: any) => {
    try {
        const response = await http.post<any>(`${ESP_ENDPOINTS?.GET_MOTOR_LOAD_DIFFERENT_FREQUENCY}`, motorLoadFrequency);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const ProjNameExists = async (projname: string, copyid: string) => {
    const params = {
        projname,
        copyid
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.CHECK_PROJECT_NAME_EXISTS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const SaveMainReportData = async (reportData: MainReport, projectId: string, unitSystem: string) => {
    const params = `projectId=${projectId}&unitSystem=${unitSystem}`;
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.SAVE_MAIN_REPORT_DATA}?${params}`, reportData);
        return response?.data
    } catch (err) {
        console.log(err, 'error data lake main report');
    }
};

export const GetCaseComparisonData = async (caseId1: string, caseId2: string, caseId3: string) => {
    const params = {
        caseId1,
        caseId2,
        caseId3
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_CASE_COMPARISION}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};